/**
 * Конфигурация пропсов компонента.
 * @typedef {Object} Props
 * @property {string} [color="white"] - Цвет лоадера. По умолчанию 'white'.
 * @property {number} [size=25] - Размер лоадера в пикселях. По умолчанию 25.
 * @property {number} [weight=5] - Толщина линии лоадера. По умолчанию 5.
 */

/**
 * Возвращает объект с настройками пропсов компонента.
 * @returns {Props} Объект с конфигурацией пропсов.
 */

export const Props = () => ({
  //Цвет loader-а
  /** @type {string} */
  color: {
    type: String,
    required: false,
    default: 'white',
  },

  //Размер Loder-а
  /** @type {number} */
  size: {
    type: Number,
    required: false,
    default: 25,
  },

  //Толщина линии Loder-а
  /** @type {number} */
  weight: {
    type: Number,
    required: false,
    default: 5,
  },
});